module.exports = __webpack_public_path__ + "img/herotext-sm.3af6c62f.png";